enum tags{
    text = "text",
    icon = "icon",
    link = "link",
    button = "button",
    linkinsametab = "linkinsametab"
}

export default tags;